<template>
<div class="view-content">
	  <div class="view-content-info">
		<div class="user-login">
		  	<div class="user-login-title"><a href="/">首页</a> / <span>帮助中心</span></div>
			<div class="center flex-between">
				<centerLeft :menu="Number(id)+9"></centerLeft>
				<div class="center-right">
					<div class="question-title">{{info.title}}</div>
					
					<div class="question-content" v-html="info.content"></div>
				</div>
			</div>
		</div>
	  </div>
	</div>
</template>

<script>
import centerLeft from '@/components/center-left.vue'
	import {qaInfo} from "@/api/index"
export default {
	name: 'index',
	components:{
		centerLeft
	},
	data(){
		return {
			id:0,
			info:{}
		}
	},
	
	watch: {
		// 直接使用$route来监听路由变化
		'$route.query': function (newQuery, oldQuery) {
			this.id = newQuery.id || "";
			this.getInfo();
		}
	},
	mounted() {
		this.id = this.$route.query.id || 0;
		this.getInfo();
		
	},
	methods:{
		getInfo(){
			qaInfo({id:this.id}).then(res=>{
				if(res.code == 1000){
					this.info = res.data;
				}else{
					return this.$message.error(res.message);
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
	.question-list{
		margin-top: 20px;
	}
	.question-title{
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		line-height: 60px;
		font-size: 16px;
		line-height: 60px;
		color: #070B13;
	
	}
	.question-content{
		margin-top: 20px;
		font-size: 16px;
		line-height: 24px;
		color: #9E9E9E;
		min-height: 800px;
	
	}
	.center-right{
		min-height: 920px;
		width: 100%;
		padding: 0px 40px;
		box-sizing: border-box;
		border-left: 1px solid rgba(0, 0, 0, 0.1);
	}
	@import url("../assets/user.scss");
</style>
